import styled from 'styled-components';

export const MaximizeContainer = styled.div`
    position: absolute;
    display: ${props => props.open ? 'flex' : 'none'};
    flex-direction: column;
    align-items: center;
    width: 781px;
    height: 600px;
    box-sizing: border-box;
    padding: 10px;
    z-index: 9999;
    right: 0;
    bottom: 0;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 5px 15px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
`;
export const MaximizeHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 43px;
    border-bottom: 1px solid #D6D6D6;
    span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 0.05em;

        color: #005178;
    }
`;
export const MaximizeContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    border-bottom: 1px solid #D6D6D6;
    margin-top: 16px;
    box-sizing: border-box;
    padding: 20px;

    overflow-y: auto;

    ::-webkit-scrollbar {
        width: 8px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #949494;
        border-radius: 4px;
    }

    .rti--container {
        width: 100%;

    }

    .rti--tag {
        padding: 5px;
        background-color: #FFF;

        span {
            font-size: 10px;
        }
    }

    input, select {
        width: 100%;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #F3F3F3;
        border-radius: 5px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 10px;
        outline: none;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #4D4D4D;
    }

    textarea {
        width: 100%;
        height: 230px;
        background: #FFFFFF;
        border-radius: 5px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 10px;
        outline: none;
        resize: none;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #4D4D4D;
    }

    .quill {
        width: 100%;
        height: 200px;
    }
`;

export const MaximizeButton = styled.button`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 162px;
    height: 40px;
    left: 20px;
    bottom: 40px;
    border-radius: 5px;
    cursor: pointer;
    background: linear-gradient(0deg, #5ABDE7, #5ABDE7), #A7A7A7;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    z-index: 1;
`